export const COLUMNS  = [
  {
    Header: "Username",
    accessor: "username",
    width: 150,
  },
  {
    Header: "First Name",
    accessor: "first_name",
    width: 100,
  },
  {
    Header: "Last Name",
    accessor: "last_name",
    width: 100,
  },
  {
    Header: "Name",
    accessor: "name",
    width: 170,
    Cell: ({ cell }) =>
      cell.row.values.first_name + ' ' + cell.row.values.last_name,
  },
  {
    Header: "Email",
    accessor: "email",
    width: 230,
  },
  {
    Header: "Role",
    accessor: "role",
    width: 50,
    Cell: (props) => 
      props.isAdmin(props.cell.row.values.username),
  }
];
